import style from "./ApkInformationAnimation.module.css";
import React, { ReactNode } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AutoPlayMutedVideo from "../../../components/AutoPlayMutedVideo";
import clsx from "clsx";

gsap.registerPlugin(ScrollTrigger);

interface ApkInformationAnimationProps {
  video: string;
  informationAlignment: ApkInformationAnimationTextAlign;
  animationAlign?: AnimationAlign;
  children?: ReactNode;
}

export enum ApkInformationAnimationTextAlign {
  Left = "Left",
  Right = "Right",
}

export enum AnimationAlign {
  Bottom = "Bottom",
  Top = "Top",
}

const ApkInformationAnimation: React.FC<ApkInformationAnimationProps> = ({
  video,
  informationAlignment,
  children,
}) => {
  const videoContainer = (
    <div className={style["video-main-container"]}>
      <div className={clsx(style["bg-mobile-view"])}>
        <AutoPlayMutedVideo
          videoSrc={video}
          classNameStyle={style["video-view"]}
        />
      </div>
    </div>
  );

  const informContainer = (
    <div className={style["info-container"]}>{children}</div>
  );

  const [firstContainer, secondContainer] =
    informationAlignment === ApkInformationAnimationTextAlign.Right
      ? [videoContainer, informContainer]
      : [informContainer, videoContainer];

  const classNameStyle =
    informationAlignment === ApkInformationAnimationTextAlign.Right
      ? style["parent-container"]
      : style["parent-container-reverse"];

  return (
    <div className={classNameStyle}>
      {firstContainer}
      {secondContainer}
    </div>
  );
};

export default ApkInformationAnimation;
